import weui from '@/wechat/weui';

import { ALERT_WECHAT_BOUND, ALERT_SHARE_BOUND } from '@/constants/text';
import {
    ROUTE_COURSE_HOME,
    ROUTE_COURSE_VIEW,
    ROUTE_SHARE_TIMES,
} from '@/router/names';
import { SHARE_TYPE_COURSE } from '@/constants/types';

export default {
    methods: {
        async unbound() {
            if (this.share.trainer) {
                // 分享课程和分享会员绑定
                // 分享可以直接关联
                if (this.share.trainer.wechat_bound) {
                    // 分享已绑定
                    if (this.share.trainer.wechat_openid !== this.wechat_user.openid) {
                        // 其它会员已绑定
                        // 确认后关窗
                        await weui.alert(ALERT_SHARE_BOUND(this.share.coach.name, this.share.trainer.name));
                        this.$wechat.closeWindow();
                        return false;
                    }
                    // 如果是课程就跳转到课程详情
                    if (this.share.type === SHARE_TYPE_COURSE) {
                        this.$router.replace({
                            name: ROUTE_COURSE_VIEW,
                            params: {
                                id: this.share.extra,
                            },
                        });
                        return false;
                    }

                    // 当前会员已绑定
                    this.$router.replace({
                        name: ROUTE_COURSE_HOME,
                    });
                    return false;
                }
                if (this.trainer && this.trainer.id) {
                    // 你已绑定了其它会员
                    // 确认后关窗
                    if (this.trainer.id !== this.share.trainer.id) {
                        await weui.alert(ALERT_WECHAT_BOUND);
                        this.$wechat.closeWindow();
                        return false;
                    }
                }
            } else if (this.trainer && this.trainer.id) {
                // 分享约课邀请
                if (this.trainer.coach_id === this.share.coach_id) {
                    // 当前教练的会员
                    // 跳转到时间选择
                    this.$router.replace({
                        name: ROUTE_SHARE_TIMES,
                        params: {
                            hash: this.hash,
                        },
                    });
                    return false;
                }
                // 绑定了其它教练
                await weui.alert(ALERT_WECHAT_BOUND);
                this.$wechat.closeWindow();
                return false;
            }

            return true;
        },
    },
};



// WEBPACK FOOTER //
// ./src/containers/share/validator.js